// // src/pages/treatments/PlasticSurgeryPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const PLASTIC_SURGERY_TREATMENT = {
//   slug: "plastic-surgery",
//   name: "Plastic & Cosmetic Surgery",
//   shortName: "Plastic Surgery",
//   tagline: "Look Your Best. Feel Confident. Expert Hands. Natural Results.",
//   heroSubtag:
//     "World-class plastic and cosmetic surgery at a fraction of Western costs. India's top board-certified plastic surgeons. Natural, lasting results.",
//   description:
//     "Comprehensive plastic and cosmetic surgery care covering facial aesthetics, body contouring, breast surgery, reconstructive surgery, burn care and non-surgical aesthetic treatments — supported by advanced anaesthesia, dedicated post-operative care and personalised recovery programmes. Our board-certified plastic surgeons review every case to deliver globally benchmarked, personalised treatment plans with outstanding aesthetic outcomes.",
//   heroImage: "/PlasticSurgery.jpeg",
//   category: "Cosmetic Surgery",
//   badge: "Advanced Aesthetic Care",
//   accentColor: "pink",
//   costCard: {
//     label: "Plastic surgery packages from",
//     value: "₹80K–₹4L",
//     compare: "vs. £5,000–£20,000 in the UK",
//     stay: "Typically 7–14 days in India depending on procedure",
//     stayCompare: "vs. $8,000–$30,000 in the USA",
//   },
//   stats: [
//     { label: "Patient Satisfaction", value: "98%+", icon: Award },
//     { label: "Procedures Performed", value: "40,000+", icon: Users },
//     { label: "Years Experience", value: "20+", icon: Shield },
//     { label: "Procedures Offered", value: "50+", icon: Clock },
//   ],
//   benefits: [
//     "Board-certified plastic surgeons with international fellowship training",
//     "3D digital imaging and simulation — visualise your results before surgery",
//     "Minimally invasive techniques — endoscopic, scarless and keyhole approaches",
//     "Combined procedures — multiple surgeries in one anaesthetic session",
//     "Dedicated post-operative recovery suites with 24/7 nursing care",
//     "Non-surgical aesthetics — Botox, fillers, laser, PRP and thread lifts",
//     "Reconstructive surgery — post-mastectomy, burn repair, cleft lip and palate",
//     "Comprehensive psychological assessment and counselling before all procedures",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Consultation & Assessment",
//       desc: "In-person consultation with your plastic surgeon — clinical examination, 3D digital imaging, surgical planning and detailed discussion of realistic outcomes and risks.",
//       duration: "1–2 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Pre-Operative Work-Up",
//       desc: "Blood tests, cardiac clearance, anaesthesia assessment, pre-operative photography and written consent covering all planned procedures.",
//       duration: "1 Day",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Surgery",
//       desc: "Procedure performed by board-certified plastic surgeon in accredited surgical facility under general or local anaesthesia with sedation.",
//       duration: "1–6 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Recovery & Follow-Up",
//       desc: "Post-operative monitoring, wound care, compression garment fitting, scar management and telemedicine follow-up after returning home.",
//       duration: "5–14 Days",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "What plastic and cosmetic surgery procedures are available in India?",
//       a: "India offers the full spectrum of plastic and cosmetic surgery including rhinoplasty, facelift, blepharoplasty, brow lift, otoplasty, breast augmentation, breast reduction, breast lift, tummy tuck (abdominoplasty), liposuction, body contouring, arm lift, thigh lift, gynecomastia correction, hair transplant, cleft lip and palate repair, post-mastectomy reconstruction and burn scar revision.",
//     },
//     {
//       q: "Are Indian plastic surgeons internationally qualified?",
//       a: "Yes. India's leading plastic surgeons hold MCh (Plastic Surgery) — the highest surgical qualification in India — and many have completed additional fellowships in the USA, UK, France or Germany. They are members of the Association of Plastic Surgeons of India (APSI) and many hold FRCS or American Board equivalence. PaxGrow only partners with board-certified, fellowship-trained surgeons.",
//     },
//     {
//       q: "What is 3D surgical simulation and how does it help?",
//       a: "3D digital imaging software (Vectra, Crisalix) creates a photorealistic 3D model of your face or body from photographs. Your surgeon uses this to simulate the expected outcome of your procedure — showing you how you might look after rhinoplasty, breast augmentation or facelift before committing to surgery. This helps align expectations and refine the surgical plan.",
//     },
//     {
//       q: "Can I combine multiple procedures in one visit?",
//       a: "Yes. Many international patients combine procedures to maximise their visit — for example, rhinoplasty with chin augmentation, or tummy tuck with liposuction and breast lift (mommy makeover). Combining procedures reduces total anaesthesia exposure, recovery time and travel costs. Your surgeon will advise on safe combinations based on your health, BMI and planned operating time.",
//     },
//     {
//       q: "How long will I need to stay in India after plastic surgery?",
//       a: "Stay duration depends on the procedure. Minimally invasive procedures (rhinoplasty, blepharoplasty, gynecomastia) typically require 7 days. Major body contouring (tummy tuck, body lift) requires 10–14 days. Most patients are cleared to fly after suture removal and wound check. PaxGrow arranges recovery accommodation with daily nursing visits before your flight.",
//     },
//     {
//       q: "What are the risks of plastic surgery in India?",
//       a: "The risks of plastic surgery in India at accredited facilities are identical to those in the UK or USA — anaesthetic risks, infection, bleeding, scarring and asymmetry. PaxGrow only partners with NABH-accredited surgical centres with full ICU backup. All surgeons carry valid professional indemnity. A pre-operative fitness assessment is mandatory for every patient.",
//     },
//     {
//       q: "What is the cost of plastic surgery in India vs. the UK or USA?",
//       a: "Plastic surgery in India costs 60–80% less than in the UK or USA. Rhinoplasty costs ₹80K–₹1.5L vs £5,000–£8,000 in the UK. Breast augmentation costs ₹1.5L–₹2.5L vs £6,000–£10,000 in the UK. Tummy tuck costs ₹1.5L–₹3L vs $8,000–$15,000 in the USA — performed by equally or better qualified surgeons with equivalent implants and anaesthetic standards.",
//     },
//     {
//       q: "Is reconstructive surgery available for burn survivors and cancer patients?",
//       a: "Yes. India has some of Asia's most experienced reconstructive plastic surgeons. Services include post-burn contracture release and skin grafting, post-mastectomy breast reconstruction (implant and DIEP flap), cleft lip and palate repair, microsurgical free flap reconstruction for head and neck cancer defects, and scar revision surgery. PaxGrow facilitates urgent reconstructive cases on a priority basis.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Debraj Shome",
//       specialty: "Facial Plastic & Oculoplastic Surgery",
//       experience: "22 Years",
//       rating: 4.9,
//       reviews: 3600,
//       image: "https://randomuser.me/api/portraits/men/52.jpg",
//       qualifications: "MBBS, MS, DNB, FRCS (Glasgow), Fellowship USA",
//       hospital: "The Esthetic Clinics, Mumbai",
//     },
//     {
//       name: "Dr. Rajiv Agarwal",
//       specialty: "Body Contouring & Reconstructive Surgery",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 2900,
//       image: "https://randomuser.me/api/portraits/men/63.jpg",
//       qualifications: "MBBS, MS, MCh (Plastic Surgery), FICS",
//       hospital: "Kokilaben Dhirubhai Ambani Hospital, Mumbai",
//     },
//     {
//       name: "Dr. Suresh Singaporewalla",
//       specialty: "Breast Surgery & Aesthetic Surgery",
//       experience: "25 Years",
//       rating: 4.8,
//       reviews: 2400,
//       image: "https://randomuser.me/api/portraits/men/71.jpg",
//       qualifications: "MBBS, MS, MCh (Plastic Surgery), FRCS",
//       hospital: "Apollo Hospitals, Chennai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Amara Diallo",
//       age: 31,
//       location: "Dakar, Senegal",
//       text: "I had been self-conscious about my nose my entire life. I researched rhinoplasty for two years before finding PaxGrow. The consultation in Mumbai was the most thorough I had ever experienced — the surgeon showed me exactly how my nose would look using 3D simulation. The result is completely natural. Nobody knows I had surgery. I only wish I had done it sooner.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/44.jpg",
//       treatment: "Open Rhinoplasty — Hump Reduction & Tip Refinement",
//       date: "November 2023",
//     },
//     {
//       name: "Nadia Hassan",
//       age: 42,
//       location: "Cairo, Egypt",
//       text: "After three pregnancies my body had changed completely. I had a tummy tuck combined with liposuction and a breast lift in one surgery at Apollo Chennai. The entire procedure took four hours. I stayed for 12 days and flew home looking and feeling completely transformed. The cost including flights and accommodation was less than the tummy tuck alone would have cost in Dubai.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/58.jpg",
//       treatment: "Mommy Makeover — Abdominoplasty, Liposuction & Breast Lift",
//       date: "January 2024",
//     },
//     {
//       name: "Chukwuemeka Obi",
//       age: 27,
//       location: "Lagos, Nigeria",
//       text: "Gynecomastia had affected my confidence since my teenage years. I was too embarrassed to go to a local surgeon. PaxGrow arranged everything discreetly. The surgery at Kokilaben Mumbai took 90 minutes under general anaesthesia. I flew home eight days later with a flat chest for the first time in my adult life. The discretion and professionalism of the entire team was outstanding.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/37.jpg",
//       treatment: "Gynecomastia Correction — Gland Excision & Liposuction",
//       date: "February 2024",
//     },
//   ],
// };

// const PLASTIC_SURGERY_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Plastic Surgery",
//   whyIndiaReasons: [
//     "NABH-accredited surgical centres with advanced 3D imaging simulation, international implant brands and full anaesthetic and ICU backup for all procedures",
//     "MCh-qualified, fellowship-trained plastic surgeons performing 500–1,000 aesthetic and reconstructive cases per year with published outcome portfolios",
//     "Consultation and surgery confirmed within 5–7 days of arrival — no 6–12 month waiting lists as in the NHS or Canadian public system",
//     "Apollo, Kokilaben, Fortis, Medanta, The Esthetic Clinics — globally recognised plastic surgery centres with verifiable patient outcome photography",
//   ],
//   conditionsTitle: "Plastic & Cosmetic Procedures We Facilitate",
//   conditions: [
//     "Rhinoplasty (Nose Reshaping)",
//     "Facelift & Neck Lift",
//     "Blepharoplasty (Eyelid Surgery)",
//     "Breast Augmentation & Reduction",
//     "Tummy Tuck (Abdominoplasty)",
//     "Liposuction & Body Contouring",
//     "Gynecomastia Correction",
//     "Hair Transplant (FUE & FUT)",
//     "Post-Mastectomy Breast Reconstruction",
//     "Burn Scar Revision & Contracture Release",
//     "Cleft Lip & Palate Repair",
//     "Mommy Makeover (Combined Procedures)",
//   ],
//   stayValue:
//     "Minor procedures: 5–7 days · Rhinoplasty & facial surgery: 7–10 days · Body contouring & breast surgery: 10–14 days. PaxGrow arranges recovery accommodation with daily nursing visits throughout.",
//   costTitle: "Why India for Plastic & Cosmetic Surgery?",
//   costRows: [
//     {
//       procedure: "Rhinoplasty (Nose Job)",
//       india: "₹80K–₹1.5L",
//       africa: "$3,000–$6,000",
//       ukusa: "$6,000–$15,000",
//     },
//     {
//       procedure: "Breast Augmentation",
//       india: "₹1.5L–₹2.5L",
//       africa: "$4,000–$8,000",
//       ukusa: "$8,000–$15,000",
//     },
//     {
//       procedure: "Tummy Tuck (Abdominoplasty)",
//       india: "₹1.5L–₹3L",
//       africa: "$4,000–$9,000",
//       ukusa: "$8,000–$18,000",
//     },
//     {
//       procedure: "Liposuction (per area)",
//       india: "₹80K–₹1.8L",
//       africa: "$2,500–$6,000",
//       ukusa: "$5,000–$12,000",
//     },
//     {
//       procedure: "Facelift & Neck Lift",
//       india: "₹2L–₹4L",
//       africa: "$6,000–$12,000",
//       ukusa: "$12,000–$30,000",
//     },
//   ],
// };

// const PlasticSurgeryPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={PLASTIC_SURGERY_TREATMENT}
//       paxgrowData={PLASTIC_SURGERY_PAXGROW}
//     />
//   );
// };

// export default PlasticSurgeryPage;

// src/pages/treatments/PlasticSurgeryPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const PLASTIC_SURGERY_TREATMENT = {
  slug: "plastic-surgery",
  name: "Plastic & Cosmetic Surgery",
  shortName: "Plastic Surgery",
  tagline: "Look Your Best. Feel Confident. Expert Hands. Natural Results.",
  heroSubtag:
    "World-class plastic and cosmetic surgery at a fraction of Western costs. India's top board-certified plastic surgeons. Natural, lasting results.",
  description:
    "Comprehensive plastic and cosmetic surgery care covering facial aesthetics, body contouring, breast surgery, reconstructive surgery, burn care and non-surgical aesthetic treatments — supported by advanced anaesthesia, dedicated post-operative care and personalised recovery programmes. Our board-certified plastic surgeons review every case to deliver globally benchmarked, personalised treatment plans with outstanding aesthetic outcomes.",
  heroImage: "/PlasticSurgery.jpeg",
  category: "Cosmetic Surgery",
  badge: "Advanced Aesthetic Care",
  accentColor: "pink",
  costCard: {
    label: "Plastic surgery packages from",
    value: "$1,000–$4,800",
    compare: "vs. $6,000–$25,000 in the UK",
    stay: "Typically 7–14 days in India depending on procedure",
    stayCompare: "vs. $8,000–$30,000 in the USA",
  },
  stats: [
    { label: "Patient Satisfaction", value: "98%+", icon: Award },
    { label: "Procedures Performed", value: "40,000+", icon: Users },
    { label: "Years Experience", value: "20+", icon: Shield },
    { label: "Procedures Offered", value: "50+", icon: Clock },
  ],
  benefits: [
    "Board-certified plastic surgeons with international fellowship training",
    "3D digital imaging and simulation — visualise your results before surgery",
    "Minimally invasive techniques — endoscopic, scarless and keyhole approaches",
    "Combined procedures — multiple surgeries in one anaesthetic session",
    "Dedicated post-operative recovery suites with 24/7 nursing care",
    "Non-surgical aesthetics — Botox, fillers, laser, PRP and thread lifts",
    "Reconstructive surgery — post-mastectomy, burn repair, cleft lip and palate",
    "Comprehensive psychological assessment and counselling before all procedures",
  ],
  procedure: [
    {
      step: "01",
      title: "Consultation & Assessment",
      desc: "In-person consultation with your plastic surgeon — clinical examination, 3D digital imaging, surgical planning and detailed discussion of realistic outcomes and risks.",
      duration: "1–2 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Pre-Operative Work-Up",
      desc: "Blood tests, cardiac clearance, anaesthesia assessment, pre-operative photography and written consent covering all planned procedures.",
      duration: "1 Day",
      icon: Activity,
    },
    {
      step: "03",
      title: "Surgery",
      desc: "Procedure performed by board-certified plastic surgeon in accredited surgical facility under general or local anaesthesia with sedation.",
      duration: "1–6 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Recovery & Follow-Up",
      desc: "Post-operative monitoring, wound care, compression garment fitting, scar management and telemedicine follow-up after returning home.",
      duration: "5–14 Days",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "What plastic and cosmetic surgery procedures are available in India?",
      a: "India offers the full spectrum of plastic and cosmetic surgery including rhinoplasty, facelift, blepharoplasty, brow lift, otoplasty, breast augmentation, breast reduction, breast lift, tummy tuck (abdominoplasty), liposuction, body contouring, arm lift, thigh lift, gynecomastia correction, hair transplant, cleft lip and palate repair, post-mastectomy reconstruction and burn scar revision.",
    },
    {
      q: "Are Indian plastic surgeons internationally qualified?",
      a: "Yes. India's leading plastic surgeons hold MCh (Plastic Surgery) — the highest surgical qualification in India — and many have completed additional fellowships in the USA, UK, France or Germany. They are members of the Association of Plastic Surgeons of India (APSI) and many hold FRCS or American Board equivalence. PaxGrow only partners with board-certified, fellowship-trained surgeons.",
    },
    {
      q: "What is 3D surgical simulation and how does it help?",
      a: "3D digital imaging software (Vectra, Crisalix) creates a photorealistic 3D model of your face or body from photographs. Your surgeon uses this to simulate the expected outcome of your procedure — showing you how you might look after rhinoplasty, breast augmentation or facelift before committing to surgery. This helps align expectations and refine the surgical plan.",
    },
    {
      q: "Can I combine multiple procedures in one visit?",
      a: "Yes. Many international patients combine procedures to maximise their visit — for example, rhinoplasty with chin augmentation, or tummy tuck with liposuction and breast lift (mommy makeover). Combining procedures reduces total anaesthesia exposure, recovery time and travel costs. Your surgeon will advise on safe combinations based on your health, BMI and planned operating time.",
    },
    {
      q: "How long will I need to stay in India after plastic surgery?",
      a: "Stay duration depends on the procedure. Minimally invasive procedures (rhinoplasty, blepharoplasty, gynecomastia) typically require 7 days. Major body contouring (tummy tuck, body lift) requires 10–14 days. Most patients are cleared to fly after suture removal and wound check. PaxGrow arranges recovery accommodation with daily nursing visits before your flight.",
    },
    {
      q: "What are the risks of plastic surgery in India?",
      a: "The risks of plastic surgery in India at accredited facilities are identical to those in the UK or USA — anaesthetic risks, infection, bleeding, scarring and asymmetry. PaxGrow only partners with NABH-accredited surgical centres with full ICU backup. All surgeons carry valid professional indemnity. A pre-operative fitness assessment is mandatory for every patient.",
    },
    {
      q: "What is the cost of plastic surgery in India vs. the UK or USA?",
      a: "Plastic surgery in India costs 60–80% less than in the UK or USA. Rhinoplasty costs $1,000–$1,800 vs $6,000–$10,000 in the UK. Breast augmentation costs $1,800–$3,000 vs $7,000–$12,000 in the UK. Tummy tuck costs $1,800–$3,600 vs $8,000–$15,000 in the USA — performed by equally or better qualified surgeons with equivalent implants and anaesthetic standards.",
    },
    {
      q: "Is reconstructive surgery available for burn survivors and cancer patients?",
      a: "Yes. India has some of Asia's most experienced reconstructive plastic surgeons. Services include post-burn contracture release and skin grafting, post-mastectomy breast reconstruction (implant and DIEP flap), cleft lip and palate repair, microsurgical free flap reconstruction for head and neck cancer defects, and scar revision surgery. PaxGrow facilitates urgent reconstructive cases on a priority basis.",
    },
  ],
  doctors: [
    {
      name: "Dr. Debraj Shome",
      specialty: "Facial Plastic & Oculoplastic Surgery",
      experience: "22 Years",
      rating: 4.9,
      reviews: 3600,
      image: "https://randomuser.me/api/portraits/men/52.jpg",
      qualifications: "MBBS, MS, DNB, FRCS (Glasgow), Fellowship USA",
      hospital: "The Esthetic Clinics, Mumbai",
    },
    {
      name: "Dr. Rajiv Agarwal",
      specialty: "Body Contouring & Reconstructive Surgery",
      experience: "28 Years",
      rating: 4.9,
      reviews: 2900,
      image: "https://randomuser.me/api/portraits/men/63.jpg",
      qualifications: "MBBS, MS, MCh (Plastic Surgery), FICS",
      hospital: "Kokilaben Dhirubhai Ambani Hospital, Mumbai",
    },
    {
      name: "Dr. Suresh Singaporewalla",
      specialty: "Breast Surgery & Aesthetic Surgery",
      experience: "25 Years",
      rating: 4.8,
      reviews: 2400,
      image: "https://randomuser.me/api/portraits/men/71.jpg",
      qualifications: "MBBS, MS, MCh (Plastic Surgery), FRCS",
      hospital: "Apollo Hospitals, Chennai",
    },
  ],
  testimonials: [
    {
      name: "Amara Diallo",
      age: 31,
      location: "Dakar, Senegal",
      text: "I had been self-conscious about my nose my entire life. I researched rhinoplasty for two years before finding PaxGrow. The consultation in Mumbai was the most thorough I had ever experienced — the surgeon showed me exactly how my nose would look using 3D simulation. The result is completely natural. Nobody knows I had surgery. I only wish I had done it sooner.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      treatment: "Open Rhinoplasty — Hump Reduction & Tip Refinement",
      date: "November 2023",
    },
    {
      name: "Nadia Hassan",
      age: 42,
      location: "Cairo, Egypt",
      text: "After three pregnancies my body had changed completely. I had a tummy tuck combined with liposuction and a breast lift in one surgery at Apollo Chennai. The entire procedure took four hours. I stayed for 12 days and flew home looking and feeling completely transformed. The cost including flights and accommodation was less than the tummy tuck alone would have cost in Dubai.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/58.jpg",
      treatment: "Mommy Makeover — Abdominoplasty, Liposuction & Breast Lift",
      date: "January 2024",
    },
    {
      name: "Chukwuemeka Obi",
      age: 27,
      location: "Lagos, Nigeria",
      text: "Gynecomastia had affected my confidence since my teenage years. I was too embarrassed to go to a local surgeon. PaxGrow arranged everything discreetly. The surgery at Kokilaben Mumbai took 90 minutes under general anaesthesia. I flew home eight days later with a flat chest for the first time in my adult life. The discretion and professionalism of the entire team was outstanding.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/37.jpg",
      treatment: "Gynecomastia Correction — Gland Excision & Liposuction",
      date: "February 2024",
    },
  ],
};

const PLASTIC_SURGERY_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Plastic Surgery",
  whyIndiaReasons: [
    "NABH-accredited surgical centres with advanced 3D imaging simulation, international implant brands and full anaesthetic and ICU backup for all procedures",
    "MCh-qualified, fellowship-trained plastic surgeons performing 500–1,000 aesthetic and reconstructive cases per year with published outcome portfolios",
    "Consultation and surgery confirmed within 5–7 days of arrival — no 6–12 month waiting lists as in the NHS or Canadian public system",
    "Apollo, Kokilaben, Fortis, Medanta, The Esthetic Clinics — globally recognised plastic surgery centres with verifiable patient outcome photography",
  ],
  conditionsTitle: "Plastic & Cosmetic Procedures We Facilitate",
  conditions: [
    "Rhinoplasty (Nose Reshaping)",
    "Facelift & Neck Lift",
    "Blepharoplasty (Eyelid Surgery)",
    "Breast Augmentation & Reduction",
    "Tummy Tuck (Abdominoplasty)",
    "Liposuction & Body Contouring",
    "Gynecomastia Correction",
    "Hair Transplant (FUE & FUT)",
    "Post-Mastectomy Breast Reconstruction",
    "Burn Scar Revision & Contracture Release",
    "Cleft Lip & Palate Repair",
    "Mommy Makeover (Combined Procedures)",
  ],
  stayValue:
    "Minor procedures: 5–7 days · Rhinoplasty & facial surgery: 7–10 days · Body contouring & breast surgery: 10–14 days. PaxGrow arranges recovery accommodation with daily nursing visits throughout.",
  costTitle: "Why India for Plastic & Cosmetic Surgery?",
  costRows: [
    {
      procedure: "Rhinoplasty (Nose Job)",
      india: "$1,000–$1,800",
      africa: "$3,000–$6,000",
      ukusa: "$6,000–$15,000",
    },
    {
      procedure: "Breast Augmentation",
      india: "$1,800–$3,000",
      africa: "$4,000–$8,000",
      ukusa: "$8,000–$15,000",
    },
    {
      procedure: "Tummy Tuck (Abdominoplasty)",
      india: "$1,800–$3,600",
      africa: "$4,000–$9,000",
      ukusa: "$8,000–$18,000",
    },
    {
      procedure: "Liposuction (per area)",
      india: "$1,000–$2,200",
      africa: "$2,500–$6,000",
      ukusa: "$5,000–$12,000",
    },
    {
      procedure: "Facelift & Neck Lift",
      india: "$2,400–$4,800",
      africa: "$6,000–$12,000",
      ukusa: "$12,000–$30,000",
    },
  ],
};

const PlasticSurgeryPage = () => {
  return (
    <TreatmentTemplate
      treatment={PLASTIC_SURGERY_TREATMENT}
      paxgrowData={PLASTIC_SURGERY_PAXGROW}
    />
  );
};

export default PlasticSurgeryPage;